// ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import React from 'react';
import { jsx } from 'theme-ui';
import ProductCardSampleRequestAction from './ProductCardSampleRequestAction';
import ProductCardTastingNoteAction from './ProductCardTastingNoteAction';

export default function ProductCardActions({ product, ...rest }) {
  const content = useContent(product);
  if (!content.hasContent) return null;
  return (
    <>
      <ProductCardTastingNoteAction product={product} />
      <ProductCardSampleRequestAction
        product={product}
        sx={{ flexShrink: 0, marginLeft: 'auto', marginBottom: 2 }}
      />
    </>
  );
}

export function useContent(product) {
  const tastingNoteAction = ProductCardTastingNoteAction.useContent(product);
  const sampleRequestAction =
    ProductCardSampleRequestAction.useContent(product);
  const hasContent =
    tastingNoteAction.hasContent || sampleRequestAction.hasContent;
  return { hasContent };
}
